export * from './has-permissions.pipe';
export * from './has-permissions.pipe.stub';
